/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_Neat_Ant_DazzleInputs */

const fr_main_neat_ant_dazzle = /** @type {(inputs: Main_Neat_Ant_DazzleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tout`)
};

/**

* @param {Main_Neat_Ant_DazzleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const main_neat_ant_dazzle = /** @type {((inputs?: Main_Neat_Ant_DazzleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_Neat_Ant_DazzleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_main_neat_ant_dazzle(inputs)
});